<template>
	<div class="violation">
		<header-bar :headerData="headerData" @childSaveUserInfo="childSaveUserInfo" v-show="callBack"></header-bar>
		<div class="query-box">
			<div class="query-input">
				<div class="input-item" v-show="phoneIsExist">
					<span class="label">手机号</span>
					<input type="tel" maxlength="13" pattern="[0-9]*" placeholder="请输入手机号码" v-model="phone" @change="changePhone">
				</div>
				<div class="input-item" v-show="verifyIsExist">
					<span class="label">验证码</span>
					<input type="text" placeholder="请输入验证码" v-model="verify" @change="changeVerify">
					<span v-if="verifyCode" class="verify-code" @click="getVerifyCode">获取验证码</span>
					<span v-else class="verify-code" style="background:#ccc;">重新获取({{second}})</span>
				</div>
				<div class="both" v-show="verifyIsExist"></div>
				<div class="input-item car-code">
					<span class="label">车牌号</span>
					<span class="car-code-head" @click="showProvinceBox" id="car_code_head">{{carCodeHead}}</span>
					<input type="text" placeholder="请输入车牌号" v-model="carCode" @change="changeCarCode">
					<select name="carType" v-model="carTypeSelected" @change="getCarTypeSelected">
						<option value="02">小车</option>
						<option value="01">大车</option>
						<option value="16">教练车</option>
					</select>
				</div>
				<div class="input-item">
					<span class="label">发动机号</span>
					<input type="text" placeholder="请输入发动机号" v-model="engine" @change="changeEngine">
					<b class="example-btn" @click="showExampleImg" id="example_btn1"></b>
				</div>
				<div class="input-item">
					<span class="label">车架号</span>
					<input type="number" maxlength="6" pattern="[0-9]*" placeholder="请输入车架号后6位" v-model="carframe" @change="changeCarframe">
					<b class="example-btn" @click="showExampleImg" id="example_btn2"></b>
				</div>
				<div class="hint-text" v-if="userAgreement">
					<span class="label">车辆信息为当地交管局查询所需，我们将严格保密，请您放心填写！点击查询即视为同意<a @click="clickPrivacyShow" id="privacy_btn">《个人信息保护声明》</a></span>
				</div>
				<div class="start-query">
					<button v-if="userInfoExist" class="query-btn" @click="startQuery">开始查询</button>
					<button v-else class="delete-btn" @click="deleteCar">删除车辆</button>
				</div>
			</div>

			<privacy-explain :privacyShow="isPrivacy" @childClosePrivacy="childClosePrivacy"></privacy-explain>
			<example-popout :popoutShow="isExampleImg" @childClosePopout="childClosePopout"></example-popout>
			<province-car :provinceModal="isProvinceModal" @childActiveItem="childActiveItem"></province-car>
		</div>
	</div>
</template>
<style scoped lang="less">

</style>
<script>
	import { Toast, Indicator } from 'mint-ui';
	import { MessageBox } from 'mint-ui';
	import HeaderBar from '@/components/violation/header';
	import PrivacyExplain from '@/components/violation/privacyExplain';
	import ExamplePopout from '@/components/violation/examplePopout';
	import ProvinceCar from '@/components/violation/province';

	export default {
		name: 'violationIndex',
		data: function() {
			return {
				callBack:true,
				headerData: {
					headerTxt: '添加车辆', //title名称
					isBackShow: true, //返回按钮 true-->显示
					isEditShow: false, //编辑按钮 true-->显示
					isSaveShow: false, //保存按钮 true-->显示
				},
				userAgreement: true, //隐私政策文本 true-->显示
				userInfoExist: true, //用户信息存在 true-->存在
				phoneIsExist: true, //电话是否存在 true-->显示
				verifyIsExist: true, //验证码是否存在 true-->显示
				carCodeHead: '京',
				isExampleImg: false, //示例图片弹框显示 true-->显示
				isProvinceModal: false, //省会简称弹框显示 true-->显示
				isPrivacy: false, //隐私说明弹框显示 true-->显示
				verifyCode: true, //重新获取验证码 true-->显示
				second: 60, //60s倒计时
				Timer: null, //定时器变量

				oldPhone: '',									//旧的手机号
				phone: '',										//手机号
				phoneNum: '',									//去掉空格的手机号
				verify: '',										//验证码
				userUUID: '1234',							//用户验证后的记录码
				carCode: '',									//车牌号
				carTypeSelected: '02',				//车类型
				engine: '',										//发动机号
				carframe: '',									//车架号
				expiration: 1000*60*60*24*30,	//localStorage过期时间
				usersInfo: {}									//发送后台数据信息
			}
		},
		created() {
			var body = document.querySelector('body')
			body.addEventListener('click', (e) => {
				if(e.target.id === 'car_code_head') {
					this.isProvinceModal = true;
				} else {
					this.isProvinceModal = false;
				}
				if(e.target.id === 'example_btn1' || e.target.id === 'example_btn2') {
					this.isExampleImg = true;
				} else {
					this.isExampleImg = false;
				}
				if(e.target.id === 'privacy_btn') {
					this.isPrivacy = true;
				} else {
					this.isPrivacy = false;
				}
			}, false)
		},
		beforeCreate: function() {
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/violation/index.css"
			});
		},
		mounted: function() {
			var self = this;

			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/violation/index.css"
			});
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);
			/***统计添加**/
			! function(e, t, n, g, i){
				e[i] = e[i] || function() {
					(e[i].q = e[i].q || []).push(arguments)
				};
				var n = t.createElement("script");
				var tag = t.getElementsByTagName("script")[0];
				n.async = 1;
				n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g;
				tag.parentNode.insertBefore(n, tag);
			}(window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/
		},
		methods: {
			webReady: function() {
				var self=this;
				this.getlocalstorage();
				document.title='添加车辆';
				if(self.$route.query.hiddenNav==1){
		  			self.callBack=false;
		  		}
				var btnChange = JSON.parse(localStorage.getItem('btnShow'));
				if(btnChange != '' && btnChange != null) {
					this.userInfoExist = btnChange.userInfoExist;
					this.phoneIsExist = btnChange.phoneIsExist;
					this.headerData.isEditShow = btnChange.isEditShow;
					this.headerData.isSaveShow = btnChange.isSaveShow;
					localStorage.removeItem('btnShow');
				}
			},
			showExampleImg: function() {
				this.isExampleImg = true;
			},
			childClosePopout: function(event) {
				this.isExampleImg = event;
			},
			showProvinceBox: function(event) {
				this.isProvinceModal = true;
			},
			childActiveItem: function(event) {
				this.carCodeHead = event.name;
				this.isProvinceModal = false;
			},
			clickPrivacyShow: function() {
				// this.isPrivacy = true;
				// privacyUtil.privacy.init();
				agreementUtil.agreement.init();
			},
			childClosePrivacy: function(event) {
				this.isPrivacy = false;
			},
			getVerifyCode: function() {
				var self = this;
				if(!this.changePhone()){ return;}
				this.verifyCode = false;
				this.Timer = setInterval(function() {
					if(self.second == 0) {
						self.verifyCode = true;
						self.second = 60;
						clearInterval(self.Timer);
					}
					self.second--;
				}, 1000);

				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.sendValidateCode,
					type: "get",
					data: {
						phone: self.phoneNum
					},
					success: function(data) {
						// console.log(data);
					},
					error: function(res) {
						console.log(res);
					}
				})
			},
			changePhone: function() {
				this.phoneNum = this.phone.replace(/\s/g, '');
				if(this.phone == '') {
					this.toastMassage('手机号不能为空！');
					return false;
				} else if(!webCommonUtil.commonFun.isPhone(this.phoneNum)) {
					this.toastMassage('请输入有效手机号！');
					return false;
				} else if(this.phone != this.oldPhone) {
					this.verifyIsExist = true;
				} else if(this.phone == this.oldPhone) {
					this.verifyIsExist = false;
				}
				return true;
			},
			changeVerify: function() {
				if(this.verifyIsExist) {
					if(this.verify == '') {
						this.toastMassage('验证码不能为空！');
						return false;
					} else if(this.verify.length != 6) {
						this.toastMassage('验证码为6位数字！');
						return false;
					}
				}
				return true;
			},
			changeCarCode: function() {
				var express = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/;
				this.carCodeNum = this.carCodeHead + this.carCode;
				if(this.carCode == '') {
					this.toastMassage('车牌号不能为空！');
					return false;
				} else if(!express.test(this.carCodeNum)) {
					this.toastMassage('请输入有效车牌号！');
					return false;
				}
				return true;
			},
			getCarTypeSelected: function() {
				// console.log(this.carTypeSelected);
			},
			changeEngine: function() {
				if(this.engine == '') {
					this.toastMassage('发动机号不能为空！');
					return false;
				}
				return true;
			},
			changeCarframe: function() {
				if(this.carframe == '') {
					this.toastMassage('车架号不能为空！');
					return false;
				} else if(this.carframe.length != 6) {
					this.toastMassage('请输入车架号后6位！');
					return false;
				}
				return true;
			},
			childSaveUserInfo: function(event) {
				var users = JSON.parse(localStorage.getItem("usersInfo"));
				// console.log(users);
				users.data.hphm = this.carCodeHead + this.carCode;
				users.data.hpzl = this.carTypeSelected;
				users.data.engineno = this.engine;
				users.data.classno = this.carframe;
				localStorage.setItem("usersInfo",JSON.stringify(users));
				// this.setlocalstorage();
				this.toastMassage('用户信息保存成功。');
			},
			toastMassage: function(msg) {
				Toast({
					message: msg,
					position: 'middle',
					duration: 3000
				});
			},
			startQuery: function() {
				if(!this.changePhone()) return;
				if(!this.changeVerify()) return;
				if(!this.changeCarCode()) return;
				if(!this.changeEngine()) return;
				if(!this.changeCarframe()) return;
				this.usersInfo = {
					phone: this.phoneNum,
					code: this.verify,
					hphm: this.carCodeHead + this.carCode,
					hpzl: this.carTypeSelected,
					engineno: this.engine,
					classno: this.carframe,
					userUUID: this.userUUID
				};
				if(!this.verifyIsExist) {
					delete this.usersInfo.code;
					this.usersInfo.userUUID = this.userUUID;
				}else{
					delete this.usersInfo.userUUID;
					this.usersInfo.code = this.verify;
				}
				this.queryCarInfo();
			},
			deleteCar: function() {
				localStorage.removeItem('usersInfo');
				this.$router.push('/mapply/violationaddcar');
			},
			getlocalstorage:function(){
				/* 判断是否到期 */
				this.userUUID =  this.getUserInfo('userUUID',this.expiration);
				var users = this.getUserInfo("usersInfo",this.expiration);
				if(users!=''&&users!=null&&JSON.stringify(users)!='{}'){
					this.verifyIsExist = false;
					this.userAgreement = false;
					this.phone = users.phone.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1 $2 $3");
					this.oldPhone = users.phone.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1 $2 $3");
					this.carCodeHead = users.hphm.slice(0, 1);
					this.carCode = users.hphm.slice(1);
					this.carTypeSelected = users.hpzl;
					this.engine = users.engineno;
					this.carframe = users.classno;
					this.userUUID = users.userUUID;
					this.usersInfo = users;
				}
			},
			setlocalstorage: function() {
				this.setUserInfo("usersInfo", this.usersInfo);
			},
			queryCarInfo: function() {
				var self = this;
				Indicator.open();
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.violationData,
					type: "post",
					data: self.usersInfo,
					success: function(data) {
						// console.log(data);
						if(data.responseHeader.status == 200) {
							var result = {
								value: data.response.result.carViolationResult.lists,
								licencePlate: data.response.result.carViolationResult.hphm
							};
							if(data.response.result.userUUID) {
								self.usersInfo.userUUID = data.response.result.userUUID;
								self.setUserInfo('userUUID', data.response.result.userUUID);
							}
							self.setlocalstorage();
							localStorage.setItem("violationData", JSON.stringify(result));
							self.$router.push('/mapply/violationresult');
						}
						Indicator.close();
					},
					error: function(res) {
						console.log(res);
					}
				})
			},
			setUserInfo: function(key, value) {
				var curTime = new Date().getTime();
				localStorage.setItem(key, JSON.stringify({
					data: value,
					time: curTime
				}));
			},
			getUserInfo: function(key, exp) {
				var data = localStorage.getItem(key);
				var dataObj = JSON.parse(data);
				if(dataObj==''||dataObj==null||JSON.stringify(dataObj)=='{}') return ;
				if(new Date().getTime() - dataObj.time>exp) {
				// console.log('信息已过期');
				localStorage.removeItem('userUUID');
				localStorage.removeItem('usersInfo');
				localStorage.removeItem('violationData');
				}else{
				var dataObjDatatoJson = dataObj.data;
				return dataObjDatatoJson;
				}
			}
		},
		components: {
			HeaderBar,
			PrivacyExplain,
			ExamplePopout,
			ProvinceCar
		},
		watch: {
			phone(newValue, oldValue) {
				if(newValue.length > oldValue.length) {
					if(newValue.length === 3 || newValue.length === 8) {
						this.phone += ' '
					}
				} else {
					if(newValue.length === 9 || newValue.length === 4) {
						this.phone = this.phone.trim()
					}
				}
			},
			carCode(newValue,oldValue){
				this.carCode = newValue.toLocaleUpperCase();
			},
			engine(newValue,oldValue){
				this.engine = newValue.toLocaleUpperCase();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/violation/index.vue